module.exports = __webpack_public_path__ + "static/media/faq_lsit.486ce391.svg";